import { simplePatch, simplePost } from "../apiConfig"

export const updateEntryApi = (entry) => {
  return simplePatch(`/mobile-record-entry/${entry.id}`, { value: entry?.value })
}

export const createEntryApi = entry => {
  const { value, mobile_record_id, form_field_id } = entry
  return simplePost(`/mobile-record-entry`, { value, mobile_record_id, form_field_id })
}
